<template>
    <div v-on:click="openChat()">
        <el-row class="notification">
            <el-col :span="4">
                <div
                    class="notification-img"
                    :style="{
                        background: getCustomTypeColor(source.CustomType),
                    }"
                >
                    {{ getShortCode(source.ShortCode) }}
                </div>
            </el-col>
            <el-col :span="20">
                <div v-if="!source.Title" class="notification-text-1">
                    <span class="notification-author">{{ source.Author }}</span>
                    {{ $t('form.label.notification.messageSent') }}
                    <span
                        class="notification-channel"
                        v-if="source.ChannelName"
                    >
                        to {{ source.ChannelName }}</span
                    >
                </div>
                <div v-if="source.Title" class="notification-text-1">
                    {{ source.Title }}
                </div>
                <div class="notification-text-2">
                    {{ source.MessageBody }}
                </div>
                <div class="notification-text-3">{{ source.CreatedAt }}</div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'stc-notification',

    props: {
        source: Object,
    },

    methods: {
        openChat() {
            if (this.source.ChannelId) {
                if (this.source.Type === 'CHAT') {
                    Events.$emit('notification-read')
                    Events.$emit('show-notification-center')
                    Events.$emit('show-chat', false)
                    Events.$emit('open-chat', false)
                    this.$nextTick(() => {
                        Events.$emit('show-chat', true)
                        this.$nextTick(() => {
                            Events.$emit(
                                'open-chat',
                                true,
                                this.source.ChannelId
                            )
                        })
                    })
                }
            }
        },

        getCustomTypeColor(type) {
            let response = '#000'
            switch (type) {
                case 'WARNING':
                    response = 'orange'
                    break
                case 'PASS':
                    response = '#2db4ff'
                    break
                case 'CRITICAL':
                    response = 'red'
                    break
                case 'TENTATIVE':
                    response = 'orange'
                    break
                case 'BLC_NOTIFICATION':
                    response = 'grey'
                    break
                case 'WANotification':
                    response = '#2db4ff'
                    break
                default:
                    break
            }
            return response
        },

        getShortCode(code) {
            return code && code.length > 3 ? code.substring(0, 3) : code
        },
    },
}
</script>

<style>
.notification {
    cursor: pointer;
    width: 290px;
}

.notification-img {
    padding-top: 8px;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
    background: #000;
    width: 40px !important;
    height: 40px !important;
    font-weight: bold;
}

.notification-read-status {
    border-radius: 50%;
    color: #fff;
    background: red;
    width: 5px !important;
    height: 5px !important;
    margin-top: 17px;
}

.notification-text-1 {
    font-size: 11px;
}

.notification-text-2 {
    font-size: 13px;
    margin: 2px 0;
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 1.1em;
}

.notification-text-3 {
    font-size: 11px;
    text-align: right;
    margin-top: 5px;
}

.notification-author {
    color: #34c7b3;
    font-weight: bold;
}

.notification-channel {
    color: #2db4ff;
    font-weight: bold;
}
</style>